import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SLICE_NAME } from './constants';
import { UsersContainerState } from './users';
import { User } from '../../domains/app';

const initialState: UsersContainerState = {
  listUsers: [],
  page: 0,
  pageSize: 20,
  total: 0,
  isFetching: false,
  search: '',
};

export const usersSlice = createSlice({
  name: SLICE_NAME,

  initialState,

  reducers: {
    setListUsers: (state, action: PayloadAction<User[]>) => {
      state.listUsers = action.payload;
    },
    addUsers: (state, action: PayloadAction<User[]>) => {
      state.listUsers = state.listUsers.concat(action.payload);
    },
    deleteUser: (state, action: PayloadAction<string>) => {
      state.listUsers = state.listUsers.filter((s) => s.id !== action.payload);
      state.total = state.total - 1;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    setTotal: (state, action: PayloadAction<number>) => {
      state.total = action.payload;
    },
    setIsFetching: (state, action: PayloadAction<boolean>) => {
      state.isFetching = action.payload;
    },
  },
});

export const {
  setListUsers,
  addUsers,
  deleteUser,
  setPage,
  setSearch,
  setTotal,
  setIsFetching,
} = usersSlice.actions;

export default usersSlice.reducer;
